<template>
  <o-card :title="title" :sync-page-title="syncPageTitle" :shadow="shadow">
    <slot name="filter"></slot>
    <div class="table-responsive">
      <table class="table table-sm">
        <thead>
        <tr>
          <slot name="head"></slot>
          <slot name="head-controls">
            <th class="text-right" v-if="enableNew">
              <router-link :to="{ path: $route.path + '/new'}" class="btn btn-primary">
                {{$t('core.new')}}
              </router-link>
            </th>
          </slot>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, itemIndex) in data.data">
          <slot name="body" :item="item">
            no controls for body slot specified
          </slot>
          <slot name="body-controls" :item="item">
            <td class="text-right" v-if="enableDelete || enableEdit">
              <div class="btn-group btn-group-sm" role="group" aria-label="edit controls">
                <o-delete v-if="enableDelete" method="delete" :url="deleteUrl() + '/' + item.id"
                          v-on:action-executed="search"></o-delete>
                <router-link v-if="enableEdit" :to="{ path: $route.path + '/' + item.id }" class="btn btn-primary">
                  <fa icon="pencil-alt"/>
                </router-link>
              </div>
            </td>
          </slot>
        </tr>
        </tbody>
        <tfoot>
        <slot name="foot"></slot>
        </tfoot>
      </table>
    </div>

    <template slot="footer">
      <o-pagination :data="data.meta.pagination" v-on:change-page="changePage"
                    class="mt-5"></o-pagination>
    </template>
  </o-card>
</template>

<script>
  import axios from 'axios'
  import qs from 'qs'

  export default {
    name: 'o-table',

    props: {
      url: {
        type: String,
        required: true
      },
      title: {
        type: String,
        default: ''
      },
      syncPageTitle: {
        type: Boolean,
        default: true
      },
      enableNew: {
        type: Boolean,
        default: true
      },
      enableEdit: {
        type: Boolean,
        default: true
      },
      enableDelete: {
        type: Boolean,
        default: true
      },
      shadow: {
        type: Boolean,
        default: true
      },
      customDelete: {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      data: {
        data: [],
        meta: {
          pagination: {
            current_page: 1
          }
        },
        filters: [],
        sortBy: 'id',
        sortByDirection: 'asc'
      }
    }),

    computed: {},

    methods: {
      changePage(page) {
        this.data.meta.pagination.current_page = page
        this.search()
      },
      search() {
        this.$root.$loading.start()

        axios
          .get(this.url, {
            paramsSerializer: qs.stringify,
            params: {
              page: this.data.meta.pagination.current_page,
              filter: this.filters,
              sortBy: this.sortBy,
              sortByDirection: this.sortByDirection
            }
          })
          .then((response) => {
            this.data = response.data
            this.$root.$loading.finish()
          })
          .catch((error) => {
            this.$root.$loading.finish()
            console.log(error)
            window.alert('could not load data from ' + this.url)
          })
      },
      setFilters(filters) {
        var flatFilters = {}
        filters.forEach((item) => {
          flatFilters[item.column] = item.value
        })
        this.filters = flatFilters
        this.search()
      },
      sortColumn (options) {
        this.sortBy = options.column
        this.sortByDirection = options.direction

        // let all table header components know what column we sort by, we need this to activate the correct indicator
        // and also clear the previous sorted column indicator
        this.$slots.head.forEach((item) => {
          if (item && item.componentOptions && item.componentOptions.tag === 'o-table-header') {
            item.componentInstance.setSortProperties(this.sortBy, this.sortByDirection)
          }
        })

        this.search()
      },
      deleteUrl() {
        let url = this.url;
        if(this.customDelete) {
          let splitUrl = url.split("?");
          if(Array.isArray(splitUrl) && splitUrl.length && 0 in splitUrl) {
            return splitUrl[0];
          }
          return url
        }
        return url
      },
      currentFilter () {
        return {
          page: this.data.meta.pagination.current_page,
          filter: this.filters,
          sortBy: this.sortBy,
          sortByDirection: this.sortByDirection
        }
      }
    },
    mounted() {
      this.search()
      this.$on('sort-column', this.sortColumn)
    }
  }

</script>
